import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";

import { PropTypes } from "prop-types";

// reactstrap components
import {
  Collapse,
  Navbar,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

import Logo from "components/Logo";
import Copyright from 'components/Footers/Copyright';
import { allChatHistories } from "network/ApiAxios";
import { useChatContext } from 'contexts/ChatContext';
import ShowByDate from './ShowByDate';
import { useSidebar } from "contexts/SidebarContext";
import SettingsModal from 'views/modals/SettingsModal';
import { useAuth } from 'contexts/AuthContext';

const Sidebar = (props) => {
  const { isOpen, toggleSidebar } = useSidebar();

  const { conversationsUpdated, resetConversationsUpdate } = useChatContext();
  const { user, signOut } = useAuth();
  const userFirstName = user?.first_name || "";
  const userLastName = user?.last_name || "";
  const [items, setItems] = useState([]);
  const [settingsModal, setsettingsModal] = useState(false);
  const [logoutError, setLogoutError] = useState("");

  const navigate = useNavigate();
  const fetchItems = useCallback(async () => {
    try {
      const response = await allChatHistories();
      if (response) {
        setItems(response.items);
      }
    } catch (error) {
      console.error('Failed to fetch chat histories:', error);
      setItems([]);
    }
  }, []);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  useEffect(() => {
    if (conversationsUpdated) {
      fetchItems();
      resetConversationsUpdate();
    }
  }, [conversationsUpdated, resetConversationsUpdate, fetchItems]);

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/auth/login');
    } catch (error) {
      setLogoutError("We couldn't sign you out. Please try again.");
    }
  };
  const toggleModal = () => {
    setsettingsModal(!settingsModal);
  };

  return (
    <>
      <Navbar
        className={`sidenav navbar navbar-vertical navbar-expand-xs border-0 fixed-start px-2 ${isOpen ? 'd-block' : 'd-none d-lg-block'}`}
        id="sidenav-main"
        style={{ zIndex: 0 }}
      >
        <div className="sidebar-header sticky-top pt-2">
          <div className='d-flex align-items-center'>
            <div className="pe-2">
              <a href="/c/" className="" style={{ textDecoration: 'none' }}>
                <Logo />
              </a>
            </div>
            
            <div className="">
              {isOpen ? (
                <button
                  className="btn p-1 m-0 shadow-none d-lg-none border-0 icon-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSidebar();
                  }}
                >
                  <i className="fa-solid fa-xmark" />
                </button>
              )
                : (
                  <a href="/c/" className="icon-btn" style={{ textDecoration: 'none' }}>
                    <i className="fa-solid fa-pen-to-square" />
                  </a>
                )
              }
            </div>
          </div>
          <hr className="horizontal dark" />
        </div>
        <Container fluid>

          {/* Collapse */}
          <Collapse navbar className='w-100' id="sidenav-collapse-main">
            {/* Navigation */}
            <ShowByDate items={items} />
          </Collapse>
        </Container>

        <div className="sidebar-footer sticky-bottom text-center">
          <UncontrolledDropdown className="dropup">
            <DropdownToggle className='user-card w-100 text-dark shadow-none bg-transparent border-0 mb-0 d-flex align-items-center'>
              <i className="fa-solid fa-circle-user sidebar-avatar-icon"></i>
              <span>{userFirstName} {userLastName}</span>
            </DropdownToggle>
            <DropdownMenu className='w-100 shadow-sm p-2'>
              <a href="#settings" onClick={(e) => { e.preventDefault(); toggleModal(); }} className="nav-link font-weight-bold p-2 d-block">
                <i className="fa-solid fa-gear me-sm-1"></i>
                <span className="d-sm-inline">Settings</span>
              </a>
              <hr className="horizontal dark my-2" />
              <a href="#dhi" onClick={(e) => { e.preventDefault(); handleLogout(); }} className="nav-linkfont-weight-bold d-block p-2">
                <i className="fa fa-user me-sm-1" aria-hidden="true"></i>
                <span className="d-sm-inline d-none">Logout</span>
              </a>
              {logoutError && <small className="text-danger d-block px-2">{logoutError}</small>}
            </DropdownMenu>
          </UncontrolledDropdown>

          <Copyright />
        </div>
      </Navbar >
      <SettingsModal isOpen={settingsModal} toggle={toggleModal} />
    </>

  );
};

Sidebar.defaultProps = {
  routes: [
  ],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
